import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AskUsAnything = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service_type: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Thank you! Your message has been sent successfully.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        service_type: "",
        message: "",
      });
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 md:py-24 bg-white" data-testid="ask-us-anything-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-0 rounded-xl overflow-hidden shadow-lg">
          {/* Left Side - Image */}
          <div className="relative h-[300px] sm:h-[400px] lg:h-auto lg:min-h-[550px]">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/e3ae400f-ac43-4e71-92d0-4fd17486a503/images/923a3295eae9d0de90cfac4bd337581fe153cdab7257ee5230130847b8bbfd68.png"
              alt="Modern Building"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right Side - Form */}
          <div className="bg-[#F4F4F4] p-6 sm:p-8 md:p-12 lg:p-16 flex items-center">
            <div className="w-full max-w-xl mx-auto">
              <h2
                className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight text-[#1A1A1A] mb-3 md:mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Ask Us Anything, Anytime.
              </h2>
              <p className="text-sm sm:text-base text-[#555555] leading-relaxed mb-6 md:mb-8">
                Expert MahaRERA Compliance Services for Developers, Promoters & Real Estate Professionals.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-slate-300 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-md p-3 md:p-4 text-sm md:text-base outline-none transition-all duration-300"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-slate-300 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-md p-3 md:p-4 text-sm md:text-base outline-none transition-all duration-300"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-slate-300 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-md p-3 md:p-4 text-sm md:text-base outline-none transition-all duration-300"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="service_type"
                      placeholder="Subject"
                      value={formData.service_type}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-slate-300 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-md p-3 md:p-4 text-sm md:text-base outline-none transition-all duration-300"
                    />
                  </div>
                </div>

                <div>
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className="w-full bg-white border border-slate-300 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-md p-3 md:p-4 text-sm md:text-base outline-none resize-none transition-all duration-300"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="inline-flex items-center gap-2 bg-[#C89B3C] hover:bg-[#B8892C] text-white px-6 md:px-8 py-3 md:py-4 rounded-md font-medium text-sm md:text-base transition-all duration-300 disabled:opacity-50"
                >
                  {isSubmitting ? "Sending..." : "Send"}
                  <ArrowRight size={18} className="md:w-5 md:h-5" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AskUsAnything;
